import { http } from './HttpService.js'

export default {
	login(data) {
		return http.post('authenticate/admin', data)
	},
	selectIdiApp(data) {
		return http.post('authenticate/app', data)
	},
	selectIdi(idi) {
		return http.get('select/idi/' + idi)
	}
}